<template>
  <div class="order-status-common">
    <!-- 待支付 -->
    <div class="status-item status-pending" v-if="status==10" >
      <div class="status-main">
        <i class="iconfont icon-icon-daizhifu"></i>{{statusShow}}
      </div>
      <div v-if="testTime" class="status-desc">支付剩余时间: &nbsp;&nbsp;{{ timeDownStr }}</div>
    </div>
    <!-- 交易成功(合同签署？) -->
    <div class="status-item status-success" v-if="status==20">
      <div class="status-main">
        <i class="iconfont icon-icon-jiaoyichenggong"></i>{{statusShow}}
      </div>
      <div class="status-desc" v-if="signingStatus==20 && trial ==0">合同已发送，待签署</div>
    </div>
    <!-- 交易关闭 -->
    <div class="status-item status-close" v-if="status==30">
      <div class="status-main">
        <i class="iconfont icon-icon-jiaoyiguanbi"></i>{{statusShow}}
      </div>
    </div>
     <!-- 待确认到账 -->
    <div class="status-item status-voucher" v-if="status==40">
      <div class="status-main">
        <i class="iconfont icon-icon-daijinzhang"></i>{{statusShow}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
            'status',
            'statusShow',
            'signingStatus',
            'trial',
            'payRemainingTime',
            'expireTime',
         ],
  data() {
    return {
      timeDownStr: '' , //倒计时的文字
      testTime:true
    }
  },
  methods: {
    addZero(n) {
      return n >= 10 ? n : '0' + n;
    },
    handleTimeLength(len) {
      const _h = parseInt(len / 3600 );
      const _m = parseInt((len % 3600) / 60);
      const _s = parseInt((len % 3600) % 60);
      this.timeDownStr = `${this.addZero(_h)}:${this.addZero(_m)}:${this.addZero(_s)}`;
    },
    startComputeTime(target) {
      let len = parseInt((target - Date.now()) / 1000);
      if(len <= 0) {
        this.testTime =false
      }
      this.handleTimeLength(len);
      len--
      const timer = setInterval(()=> {
        if(len <= 0) {
          this.testTime =false
          return clearInterval(timer);
        }
        this.handleTimeLength(len);
        len--
      }, 1000)
    },
    
  },
  created() {
    // 从props中获得到期时间！！！！
    const target = new Date(this.expireTime).getTime();
    this.startComputeTime(target);
  },

}
</script>

<style lang="scss" scoped>
.order-status-common {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // align-items: center;
  text-align: center;
  .status-item {
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    .iconfont {
      margin-right: 4px;
      font-size: 14px;
    }
    .status-main {
      height: 18px;
      line-height: 18px;
      font-size: 14px;
    }
    .status-desc {
      margin-top: 4px;
      height: 16px;
      line-height: 16px;
      font-size: 12px;
    }
    &.status-pending {
      color: #FF7F2A;
    }
    &.status-success {
      color: #20B820;
      .status-desc {
        color: #EF2A2A;
      }
    }
    &.status-close {
      color: #4F5D78;
    }
    &.status-voucher{
      color: #318CED;
    }
  }
}
</style>